import * as encoding from 'lib0/encoding';
import * as decoding from 'lib0/decoding';
export { extractText, extractContent, extractDocInfo } from './yjs-utils.js';
export function debounce(fn, ms) {
    let timeout = null;
    let firstCallTime = null;
    function execute(...args) {
        timeout = null;
        firstCallTime = null;
        fn(...args);
    }
    return {
        call(...args) {
            const now = Date.now();
            if (firstCallTime === null) {
                firstCallTime = now;
            }
            if (timeout) {
                clearTimeout(timeout);
            }
            const elapsed = now - firstCallTime;
            const remaining = ms - elapsed;
            if (remaining <= 0) {
                execute(...args);
            }
            else {
                timeout = setTimeout(() => execute(...args), remaining);
            }
        },
        cancel() {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            firstCallTime = null;
        },
    };
}
export var SyncMessageType;
(function (SyncMessageType) {
    SyncMessageType[SyncMessageType["SYNC_REQUEST"] = 0] = "SYNC_REQUEST";
    SyncMessageType[SyncMessageType["SYNC_RESPONSE"] = 1] = "SYNC_RESPONSE";
    SyncMessageType[SyncMessageType["UPDATE"] = 2] = "UPDATE";
    SyncMessageType[SyncMessageType["SYNC_RESET"] = 3] = "SYNC_RESET";
})(SyncMessageType || (SyncMessageType = {}));
// Maximum message size: 1 MiB
const MAX_MESSAGE_SIZE = 1024 * 1024;
export function encodeMessage(msg) {
    const encoder = encoding.createEncoder();
    encoding.writeVarUint(encoder, msg.type);
    encoding.writeVarString(encoder, msg.documentId);
    switch (msg.type) {
        case SyncMessageType.SYNC_REQUEST:
            encoding.writeVarUint8Array(encoder, msg.stateVector);
            break;
        case SyncMessageType.SYNC_RESPONSE:
            encoding.writeVarUint8Array(encoder, msg.update);
            encoding.writeVarUint8Array(encoder, msg.stateVector);
            break;
        case SyncMessageType.UPDATE:
        case SyncMessageType.SYNC_RESET:
            encoding.writeVarUint8Array(encoder, msg.update);
            break;
    }
    const encoded = encoding.toUint8Array(encoder);
    if (encoded.length > MAX_MESSAGE_SIZE) {
        throw new Error('Message exceeds maximum size of 1 MiB');
    }
    return encoded;
}
export function decodeMessage(data) {
    if (data.length > MAX_MESSAGE_SIZE) {
        throw new Error('Message exceeds maximum size of 1 MiB');
    }
    const decoder = decoding.createDecoder(data);
    const type = decoding.readVarUint(decoder);
    const documentId = decoding.readVarString(decoder);
    switch (type) {
        case SyncMessageType.SYNC_REQUEST:
            return { type, documentId, stateVector: decoding.readVarUint8Array(decoder) };
        case SyncMessageType.SYNC_RESPONSE:
            return {
                type,
                documentId,
                update: decoding.readVarUint8Array(decoder),
                stateVector: decoding.readVarUint8Array(decoder),
            };
        case SyncMessageType.UPDATE:
            return { type, documentId, update: decoding.readVarUint8Array(decoder) };
        case SyncMessageType.SYNC_RESET:
            return { type, documentId, update: decoding.readVarUint8Array(decoder) };
        default:
            throw new Error(`Unknown message type: ${type}`);
    }
}
//# sourceMappingURL=index.js.map